<template lang="pug">
.a_1_ui
    .r4k
        Content

</template>

<script>
import Content from './A_1_Content'
import ResizeService from '@/services/ResizeService'
import FontService from '@/services/FontService'
export default {
    components:{
        Content
    },
    mounted(){
        //如果试竖屏 调用updateDirection('v)
        //如果横屏 直接ResizeService.getInstance()
        ResizeService.getInstance().updateDirection('h')
        //这个必须调用
        FontService.getInstance()
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.a_1_ui
    +full()
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    .r4k
        background: #ccc

</style>